<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { PageHeaderMenuItem } from '~/components/page/header/menu/PageHeaderMenu.vue'
import { ApiInsuranceBankInsurance } from '~~/server/api/insurance/bank/insurance'

const route = useRoute()
const { data: page, redirect } = await useFetchWithRedirect<ApiInsuranceBankInsurance>(
    '/api/insurance/bank/insurance',
    { route }
)
const { isLandscape } = useCheckDeviceOrientation()
const { pageHeaderMenu } = usePageHeaderMenu()
if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

const sections = computed<PageHeaderMenuItem[]>(() => {
    const menu: PageHeaderMenuItem[] = []

    if (!page.value) return []

    if (page.value.data.insurance_products) {
        menu.push({
            title: page.value.data.insurance_products.title || '',
            hash: '#poistne-produkty',
        })
    }

    if (page.value.data.bank_products) {
        menu.push({
            title: page.value.data.bank_products.title || '',
            hash: '#bankove-produkty',
        })
    }

    if (page.value.data.damage_report) {
        menu.push({
            title: page.value.data.damage_report.title || '',
            hash: '#ako-nahlasit-skodovu-udalost',
        })
    }

    menu.push({ title: 'Kontakty', hash: '#kontakty' })

    return menu
})

const activeSection = ref(false)

const handleActiveSection = (section: boolean) => {
    activeSection.value = section
}

// Schema.org
useSchemaOrg([
    defineWebPage({
        name: page.value?.data.title,
        image: page.value?.data?.headline?.image?.path?.['1540x0']?.url || '',
    }),
])

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
    og_type: 'product'
})
</script>
<template>
  <section v-if="page">
    <ContainerFluid>
      <Breadcrumbs
        :current="page.data.title"
        :links="[]"
      />
    </ContainerFluid>
    <PageHeader
      :title="page.data.title"
      :headline="page.data.headline"
      :sections="sections"
      class="mb-12 mb-md-40"
      @active-section="handleActiveSection($event)"
    />
    <ContainerFluid :class="{ 'top-space-60': activeSection && !isLandscape && pageHeaderMenu.show }">
      <PagesBankInsuranceProducts
        class="mb-12 mb-md-20 scroll-margin-top-11"
        :data="page.data.insurance_products"
      />
      <LazyPagesBankInsuranceProductsTabs
        class="mb-12 mb-md-40 scroll-margin-top-11"
        :data="page.data.insurance_products"
      />
      <LazyPagesBankInsuranceBankProducts
        :data="page.data.bank_products"
        class="mb-12 mb-md-20 scroll-margin-top-11"
      />
      <LazyPagesBankInsuranceBankProductsTabs
        class="mb-12 mb-md-40 scroll-margin-top-11"
        :data="page.data.bank_products"
      />
      <LazyPagesBankInsuranceDamageReport
        class="scroll-margin-top-11"
        :data="page.data.damage_report"
      />
      <LazyPagesBankInsuranceContactsSection :data="page.data.contacts" />
    </ContainerFluid>
  </section>
</template>
